// extracted by mini-css-extract-plugin
export default {"vulnerability-break-down":"vulnerabilityBreakDown_vulnerability-break-down__l9pMB"};